<div class="border border-gray-300 rounded-xl overflow-hidden bg-white shadow-sm">
    <!-- Table section with scrolling -->
    <div class="overflow-x-auto max-h-[600px] overflow-y-auto">
        <table class="w-full text-left border-collapse">
            <!-- Table Header -->
            <thead class="bg-[#eef0f3] border-b border-gray-300 sticky top-0">
                <tr class="w-full">
                    <th class="px-6 py-4 text-sm text-[#808080]">#</th>
                    <th class="px-6 py-4 text-sm text-[#808080] min-w-[190px]">Request</th>
                    <th class="px-6 py-4 text-sm text-[#808080] min-w-[160px]">Requested</th>
                    <th class="px-6 py-4 text-sm text-[#808080] min-w-[170px]">Action</th>
                    <th class="px-6 py-4 text-sm text-[#808080] min-w-[210px]">Range</th>
                    <th class="px-6 py-4 text-sm text-[#808080] min-w-[220px]">Status</th>
                </tr>
            </thead>

            <!-- Table Body -->
            <tbody *ngIf="!isLoading">
                <tr *ngFor="let row of tableData; let i = index"
                    (click)="requestToDetail(row)"
                    [ngClass]="i % 2 === 0 ? 'bg-white hover:bg-gray-50' : 'bg-[#fbfbfc] hover:bg-gray-50'"
                    class="transition-colors cursor-pointer">
                    <td class="px-6 py-3 !text-[15px] text-gray-700">{{ (pageIndex * pageSize) + i + 1 }}</td>
                    <!-- Other Columns -->
                    <td class="px-6 py-3 !text-[15px] text-gray-700 min-w-[190px]">
                        <div class="flex items-center gap-2">
                            <span class="material-symbols-outlined !text-[20px] text-gray-400">
                                {{ row.request_type === 'Team' ? 'groups' : 
                                   (row.employee_id ? 'person' : 'corporate_fare') }}
                            </span>
                            <span>{{row.name}}</span>
                            <span *ngIf="row.isSystemJob"
                                class="ml-1 inline-flex items-center px-2 py-[2px] rounded-full bg-slate-50 text-slate-600 text-[11px] font-semibold border border-slate-200 cursor-default select-none whitespace-nowrap">
                                System
                            </span>
                        </div>
                    </td>
                    <td class="px-6 py-3 text-[13px] text-gray-700 min-w-[160px] whitespace-nowrap">{{row.created_at}}</td>
                    <!-- Request -->
                    <td class="px-6 py-3">
                        <span
                            class="inline-flex items-center px-2.5 py-1 rounded-full bg-slate-100 text-slate-700 text-[12px] font-semibold border border-slate-200 cursor-default select-none whitespace-nowrap">
                            {{ getActionLabel(row) }}
                        </span>
                    </td>

                    <!-- Range -->
                    <td class="px-6 py-3 text-[13px] text-gray-700 min-w-[210px] whitespace-nowrap">{{ row.range }}</td>


                    <!-- Status (single consolidated outcome) -->
                    <td class="px-6 py-3">
                        <div class="min-h-[36px] flex items-center">
                            <!-- Export ready: show Download as the primary status -->
                            <a *ngIf="isDownloadableRow(row) && !isDownloadLinkExpired(row)"
                                [href]="row.download_link" target="_blank"
                                (click)="$event.stopPropagation()"
                                class="flex items-center gap-1.5 px-2 py-[3px] bg-[#4b50c7] hover:bg-[#4348b6] text-white rounded-md text-[11px] font-semibold transition-colors w-fit">
                                <span class="material-symbols-outlined !text-[15px]">download</span>
                                <span>Download</span>
                            </a>

                            <!-- Export expired: show Completed with tooltip -->
                            <span *ngIf="isDownloadableRow(row) && isDownloadLinkExpired(row)"
                                class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-slate-100 text-slate-700 text-[12px] font-semibold border border-slate-200 cursor-default select-none whitespace-nowrap"
                                matTooltip="Download link expired"
                                matTooltipPosition="above">
                                Completed
                                <span class="material-symbols-outlined !text-[16px] text-gray-500">schedule</span>
                            </span>

                            <!-- No data -->
                            <span *ngIf="row.action == 'Download' && row.status == 'Completed' && (row.download_link === 'NO_SCREENSHOT_AVAILABLE' || row.download_link === 'NO_LOGS_AVAILABLE')"
                                class="inline-flex items-center px-2.5 py-1 rounded-full bg-slate-100 text-slate-600 text-[12px] font-semibold border border-slate-200 whitespace-nowrap cursor-default select-none">
                                No data
                            </span>

                            <!-- Completed delete: system retention vs user delete -->
                            <span *ngIf="row.action == 'Delete' && row.status == 'Completed' && row.isSystemJob"
                                class="inline-flex items-center px-2.5 py-1 rounded-full bg-slate-100 text-slate-700 text-[12px] font-semibold border border-slate-200 whitespace-nowrap cursor-default select-none">
                                Completed
                            </span>

                            <span *ngIf="row.action == 'Delete' && row.status == 'Completed' && !row.isSystemJob"
                                class="inline-flex items-center px-2.5 py-1 rounded-full bg-emerald-50 text-emerald-700 text-[12px] font-semibold border border-emerald-100 whitespace-nowrap cursor-default select-none">
                                Deleted
                            </span>

                            <!-- Failed -->
                            <span *ngIf="row.status == 'Failed'"
                                class="inline-flex items-center gap-1 text-[12px] text-gray-700 leading-none cursor-default select-none"
                                [matTooltip]="genericFailedMessage"
                                matTooltipPosition="above">
                                <span>Failed</span>
                                <span class="material-symbols-outlined !text-[16px] text-gray-500">info</span>
                            </span>

                            <!-- In progress / other statuses -->
                            <span *ngIf="row.status !== 'Failed'
                                && !(row.action == 'Delete' && row.status == 'Completed')
                                && !(row.action == 'Download' && row.status == 'Completed')
                                && !(isDownloadableRow(row) && !isDownloadLinkExpired(row))"
                                [ngClass]="row.status | statusClass"
                                class="capitalize inline-flex items-center justify-center gap-1.5 px-[10px] py-[5px] rounded-[30px] w-fit min-w-[120px]">
                                <svg *ngIf="row.status == 'Processing'" class="animate-spin"
                                    xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                                </svg>
                                <span class="!text-[14px]">
                                    {{row.status}}
                                </span>
                            </span>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- Loader & Empty State -->
        <div class="px-2 py-4 w-full">
            <!-- Skeleton Loader -->
            <div *ngIf="isLoading" class="w-full">
                <ngx-skeleton-loader count="6" style="width: 100%"
                    [theme]="{ 'border-radius': '6px', height: '50px', 'margin-bottom': '0px'}">
                </ngx-skeleton-loader>
            </div>

            <!-- Empty State -->
            <div *ngIf="!isLoading && (!tableData || tableData.length === 0)"
                class="flex flex-col items-center justify-center py-10">
                <img src="assets/images/empty_list.png" alt="empty list image" class="max-w-[200px] opacity-80" />
            </div>
        </div>
    </div>

    <!-- Footer row: toggle on left, pagination on right -->
    <div *ngIf="!isLoading" class="flex items-center justify-between border-t border-gray-200">
        <div class="px-4 py-2 text-[12px] text-gray-500">
            <mat-checkbox class="text-[12px]" [checked]="!!filters.showAutomated"
                (change)="onToggleShowAutomated($event.checked)">
                Show automated jobs
            </mat-checkbox>
        </div>

        <mat-paginator [length]="totalItems" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
            aria-label="Select page" (page)="onPaginateChange($event)">
        </mat-paginator>
    </div>
</div>